import React, { Component} from 'react';

//Material UI
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { ClientDocuments } from '../Business/ClientDocuments';
import { SelectListFilterable } from '../Utilities/SelectListFilterable';
import { TextInput } from '../Utilities/TextInput';
import { ModalDialog } from '../Utilities/ModalDialog'
import { UserAvatar } from '../Utilities/UserAvatar'
import { SectionItem } from '../Utilities/SectionItem';
import { Section } from '../Utilities/Section';
import { Invitation } from '../Invitations/Invitation';
import { ItemCreator } from '../Utilities/ItemCreator';
//Database Services
import { getClientUserData, isAdminUser, getClients, getClientDocs, newClient, editClient, getClientUsers, getClientUserInvites, newClientUser, deleteClientUser } from '../../DataServices/BusinessService'
import { getEnums } from '../../DataServices/Utility'
import { newOwnerFolder, } from '../../DataServices/DocumentService'
import { sendEmail} from '../../DataServices/EmailService'




export class Home extends Component {

    constructor(props) {
        super(props);
        this.props.setToken.bind(this);
        this.state = {
            documentFolders: [],      
            contentUser: false,
            contentLoaded: false,
            dropDownOptions: [],
            selectedContentType: null,
            selectedContentProps: null,
            contentUser: true,
            pauseRefreshes: false,
            bottomMenuValue: 0,
            contentLoading: false,
            height: 0,
            width: 0,
            newClientUserFields : [
                {
                    type: "text",
                    label: "First Name",
                    fieldName: "firstName",
                    value: "",
                    maxLength: 100,
                    required: true
                },
                {
                    type: "text",
                    label: "Last Name",
                    fieldName: "lastName",
                    value: "",
                    maxLength: 100,
                    required: true
                },
                {
                    type: "text",
                    label: "Email",
                    fieldName: "email",
                    value: "",
                    maxLength: 100,
                    required: true,
                    format: "email",
                    validateOnBlur: true
                },
                {
                    type: "text",
                    label: "Default Password",
                    fieldName: "password",
                    value: "Pa$$w0rd",
                    maxLength: 100,
                    required: true
                },
            ]
            //selectedClient: { label: "Test Personal", value: "Test Personal" }
        }
    }

    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);

        this.getData();

    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    updateWindowDimensions = () => {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    }


    //Data Fetching
    getData = async () => {
        const isAdmin = await isAdminUser(this.props.user.userID, this.props.businessID);
        this.setState({ isAdmin });
        this.props.setIsAdmin(isAdmin);
       // this.getClientData();
        if (isAdmin === true) {
            this.getClientList();
        }
        else {
            this.getClientData();
        }

    }
    getDropdownOptions = async () => {
        const data = await getEnums();
        this.setState({ dropDownOptions: data });
    }
    getClientList = async () => {
        const clientData = await getClients(this.props.businessID);
        const clientList = [];
      
        if (clientData && clientData.length > 0) {
            for (var i = 0; i < clientData.length; i++) {
                clientList.push({ label: clientData[i].name, value: clientData[i].id });
            }
            this.setState({ clientData, clientList });
        }
    }

    getClientData = async () => {
        const clientData = await getClientUserData();
        const clientList = [];
        if (clientData && clientData.length > 0) {
            for (var i = 0; i < clientData.length; i++) {
                clientList.push({ label: clientData[i].name, value: clientData[i].id });
            }
            this.setState({ clientData, clientList });
        }

    }

    setCurrentFolders = (clientID, clientData) => {
        if (clientID) {
            if (this.state.clientData) {
                var client = this.state.clientData.find(c => {
                    return c.id === clientID
                })
            }
            else {
                var client = clientData.find(c => {
                    return c.id === clientID
                })
            }
            const documentFolders = [];
            if (client) {
                if (client.documentFolders && client.documentFolders.length > 0) {
                    for (var j = 0; j < client.documentFolders.length; j++) {
                        if (client.documentFolders[j] && client.documentFolders[j].id) {
                            if (client.documentFolders[j].id === "ARCHIVE") {
                                if (this.props.isAdmin) {
                                    documentFolders.push(client.documentFolders[j]);
                                }
                            }
                            else {
                                documentFolders.push(client.documentFolders[j]);
                            }
                
                        }
                    }
                }
            }
            this.setState({ documentFolders });


        }


    }
    handleClientChange = (e) => {

        this.setCurrentFolders(e);

        var client = this.state.clientData.find(c => {
            return c.id === e
        })

        this.setState({ selectedClient: e, selectedClientName : client.name});
    }
    updateFolders = (documentFolders) => {

        this.setState({ documentFolders });

    }
    selectClient = async (clientID) => {
        if (clientID) {
            var client = this.state.clientData.find(c => {
                return c.id === clientID.value
            })

            const documentFolders = await getClientDocs(clientID.value);
            const inv = await getClientUserInvites(clientID.value);
            const usrs = await getClientUsers(clientID.value);


            this.setState({ documentFolders, selectedClient: clientID.value, selectedClientName: client.name, inv, usrs });
        }
        else {
            const documentFolders = [];

            this.setState({ documentFolders, selectedClient: null, selectedClientName: null });
        }

        
    }
    handleManageClientUsers = () => { }
    handleEditClient = () => { }

    clientSelect = () => {
        if (this.state.clientList) {
            return (
                <Autocomplete
                    loadingText="Loading Clients"
                    onChange={(e, val) => this.selectClient(val) }
                    disablePortal
                    id="clientselector"
                    options={this.state.clientList}
                    sx={{
                        minWidth: 300,
                        color: (theme) => this.props.dark ? theme.palette.common.white : theme.palette.common.black,
                                    fontSize: ".8rem"                    }}
                    renderInput={(params) =>
                        <TextField
                            {...params}
                            placeholder="Start Typing Name"
                            sx={{
                                color: (theme) => this.props.dark ? theme.palette.common.white : theme.palette.common.black,
                                fontSize: ".8rem"
} }

                        />}
                />
                
                
                )
        }
    }
    clientAdder = () => {
        return (
            <ModalDialog
                {...this.props}
                show={this.state.showNewClient}
                title={this.state.mode === "new" ? "New Client" : "Edit Client"}
                handleClose={() => this.setState({ showNewClient: false })}
                handleSave={this.state.mode === "new" ? this.handleSaveNewClient : this.handleSaveEditClient}
                fullWidth={true}
                maxWidth="sm"
                closeLabel="Close"

            >
                <TextInput
                    {...this.props}
                    cKey="CnewClientName"
                    cid="CnewClientName"
                    id="fldClientName"
                    label="Client Name"
                    defaultValue={this.state.nameValue}
                />
                <TextInput
                    {...this.props}
                    cKey="CnewClientAltID"
                    cid="CnewClientAltID"
                    id="fldClientAltID"
                    label="Alt ID"
                    defaultValue={this.state.altIdValue}
                />
            </ModalDialog>
        )
    } 
    handleShowEditClient = () => {
        const id = this.state.selectedClient;

        this.setState({
            anchorEl: null,
            showNewClient: true,
            mode: "edit",
            nameValue: this.state.clientData.find((x) => x.id === id).name,
            altIdValue: this.state.clientData.find((x) => x.id === id).clientAltID,
        });
    }
    handleSaveNewClient = async () => {
        const ele = document.getElementById("fldClientName");
        if (!ele)
            return;
        const name = ele.value;
        ele.value = "";
        const ele2 = document.getElementById("fldClientAltID");
        if (!ele2)
            return;
        const altid = ele2.value;
        ele2.value = "";

        const newClt = await newClient(this.props.businessID, name, altid);
        if (newClt) {
            const clientData = this.state.clientData;
            clientData.push(newClt);

            const clientList = this.state.clientList;
            clientList.push({ label: newClt.name, value: newClt.id });
            
            await newOwnerFolder("Uploads", this.props.user.userID, newClt.id, this.props.appIdentifier);
           
            const documentFolders = await getClientDocs(newClt.id);

            this.setState({ clientData, clientList, documentFolders, selectedClient: newClt.id, selectedClientName: newClt.name, showNewClient: false, mode: null });
            let ele3 = document.getElementById("clientselector");
            if (ele3) {
                ele3.value = newClt.id;
            }


        }
    }
    handleSaveEditClient = async () => {
        const ele = document.getElementById("fldClientName");
        if (!ele)
            return;
        const name = ele.value;
        ele.value = "";
        const ele2 = document.getElementById("fldClientAltID");
        if (!ele2)
            return;
        const altid = ele2.value;
        ele2.value = "";

        const newClt = await editClient(this.state.selectedClient, name, altid);
        if (newClt) {
            this.setState(
                state => {
                    let clientData = state.clientData;
                    clientData.find((x) => x.id === this.state.selectedClient).name = name;
                    clientData.find((x) => x.id === this.state.selectedClient).clientAltID = altid;
                    let clientList = state.clientList;
                    clientList.find((x) => x.value === this.state.selectedClient).label = name;
                    return {
                        clientData,
                        clientList,
                        showNewClient: false,
                        selectedClientName: name,
                        mode: null
                    };
                }
            );

        }
    }

    addNewClient = () => {
        this.setState({mode: "new", showNewClient: true, nameValue: "", altIdValue: "" })

    }
    adminTools = () => {
        return (
            <Stack direction="row" spacing={2} sx={{ mx: 1, width:"-webkit-fill-available" }}>
                {this.clientSelect()}

     
                {(this.state.documentFolders && this.state.documentFolders.length > 0) &&
                    <>
                        <Button
                            variant="contained"
                            size="small"
                            color="secondary"
                            aria-label="newdoc"
                        onClick={this.handleShowEditClient}
                        >
                            Edit Client
                        </Button>
                        <Button
                            variant="contained"
                            size="small"
                            color="secondary"
                            aria-label="newdoc"
                        onClick={() => this.setState({ showClientUsers: true })}
                        >
                            Manage Client Users
                        </Button>
                    </>
                }
                <Box sx={{ flexGrow: 1 }} />
                <Button
                    variant="contained"
                    size="small"
                    color="secondary"
                    aria-label="newclient"
                    onClick={this.addNewClient}
                >
                    Add New Client
                </Button>
            </Stack>
        )

    }
    deleteClientUser = async (id, idx) => {
        const res = deleteClientUser(id);
        const usrs = this.state.usrs;
        usrs.splice(idx, 1);
        this.setState({ usrs });

    }
    handleClientUsers = async () => {

        const inv = await getClientUserInvites(this.state.selectedClient);
        if (inv) {
            this.setState({ inv });
        }


        const usrs = await getClientUsers(this.state.selectedClient);
        if (usrs) {
            this.setState({ usrs });
        }
    }
    handleShowNewClientContact = () => {

    }
    sendInvite = async  (user) => {
        const htmlContent = `
<!DOCTYPE html>
<html lang="en">
  <body style="margin:0;padding:0;background-color:#f4f4f4;">
    <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="background-color:#f4f4f4;padding:20px 0;">
      <tr>
        <td align="center">
          <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="max-width:600px;background-color:#ffffff;border-radius:8px;overflow:hidden;border:1px solid #e0e0e0;">
            <!-- Header -->
            <tr>
              <td style="background-color:#123a5d;padding:20px 30px;text-align:left;">
                <h1 style="margin:0;font-family:Arial,Helvetica,sans-serif;font-size:20px;line-height:1.4;color:#ffffff;">
                  Stallings and Associates Client Portal
                </h1>
              </td>
            </tr>

            <!-- Content -->
            <tr>
              <td style="padding:25px 30px 30px 30px;font-family:Arial,Helvetica,sans-serif;color:#333333;font-size:14px;line-height:1.6;">

                <p style="margin:0 0 12px 0;">
                  Hi ${user.firstName},
                </p>

                <p style="margin:0 0 12px 0;">
                  You have been added as a user for
                  <strong>${this.state.selectedClientName}</strong> in the
                  <strong>Stallings and Associates Client Portal</strong>.
                </p>

                <p style="margin:0 0 12px 0;">
                  You will be able to use this portal to securely access files that
                  Stallings and Associates has shared with you and to securely upload
                  any requested or required documentation.
                </p>

                <!-- Login details -->
                <p style="margin:18px 0 8px 0;font-weight:bold;">
                  Your login details
                </p>

                <p style="margin:0 0 8px 0;">
                  <strong>Portal URL:</strong>
                  <br />
                  <a href="https://mylivesphere.com/portals/stallingsandassociates"
                     target="_blank"
                     style="color:#1a73e8;text-decoration:none;">
                    Client Portal
                  </a>
                </p>

                <p style="margin:0 0 6px 0;">
                  <strong>Username:</strong>
                  <span style="font-family:'Courier New',monospace;background-color:#f0f0f0;padding:2px 5px;border-radius:3px;">
                    ${user.email}
                  </span>
                </p>

                <p style="margin:0 0 10px 0;">
                  <strong>Temporary Password:</strong>
                  <span style="font-family:'Courier New',monospace;background-color:#f0f0f0;padding:2px 5px;border-radius:3px;">
                    Pa$$w0rd
                  </span>
                </p>

                <p style="margin:0 0 16px 0;font-size:12px;color:#666666;">
                  For security, you may be prompted to change your password after you sign in.  If not click on the account item in the menu in the upper right of the screen, then select the option to change password.
                </p>

                <!-- Access instructions -->
                <p style="margin:0 0 12px 0;">
                  To access the portal, you can:
                </p>

                <ul style="margin:0 0 12px 20px;padding:0;color:#333333;font-size:14px;">
                  <li style="margin-bottom:6px;">
                    Navigate to
                     <a href="http://stallingsandassociates.com"
                     target="_blank"
                     >
                    Stallings and Associates Website
                  </a>  and click the
                    <strong>Client Portal</strong> link in the upper right, or
                  </li>
                  <li>
                    Access it directly using this link:

                  </li>
                </ul>

                <!-- Button -->
                <p style="margin:14px 0 20px 0;text-align:center;">
                  <a href="https://mylivesphere.com/portals/stallingsandassociates"
                     target="_blank"
                     style="display:inline-block;padding:11px 22px;background-color:#123a5d;color:#ffffff;text-decoration:none;border-radius:5px;font-weight:bold;font-size:14px;">
                    Open Client Portal
                  </a>
                </p>

                <!-- Help text -->
                <p style="margin:0 0 12px 0;">
                  If you have any trouble signing in or believe this email was sent to you
                  in error, please contact us at
                  <a href="mailto:info@stallingsandassociates.com"
                     style="color:#1a73e8;text-decoration:none;">
                    info@stallingsandassociates.com
                  </a>
                  or call (757) 365-0200.
                </p>

                <p style="margin:16px 0 0 0;">
                  Thank you,<br />
                  <strong>Stallings and Associates</strong>
                </p>
              </td>
            </tr>

            <!-- Footer -->
            <tr>
              <td style="padding:12px 20px 18px 20px;text-align:center;font-family:Arial,Helvetica,sans-serif;font-size:11px;color:#888888;background-color:#f9f9f9;">
                This is an automated message from Stallings and Associates.
                Please do not reply directly to this email.
                <br />
                Stallings and Associates  All rights reserved.
              </td>
            </tr>

          </table>
        </td>
      </tr>
    </table>
  </body>
</html>

`;
        if (await sendEmail(user.email, user.firstName + " " + user.lastName, "Client Portal Login Information", htmlContent, "", "LS")) {

            alert("Welcome email has been sent successfully!");
        } else {
            alert("There was a problem sending the email.");
        }
  
        //await sendEmail(this.props.notificationEmail, this.props.notificationName ?? "", 'New Website Message', h, '', "LS");
    }
    clientUsers = () => {
        if (this.state.showClientUsers) {
            return (
                <ModalDialog
                    {...this.props}
                    show={this.state.showClientUsers}
                    title={"Client Users"}
                    handleClose={() => this.setState({ showClientUsers: false })}
                    fullWidth={true}
                    maxWidth="lg"
                    closeLabel="Close"

                >
                    <Section
                        title=" "
                        key="cliusers"
                        fullWidth
                        dark={this.props.dark}
                        flat
                        transparent
                        handleAdd={() => this.setState({ showNewClientUser: true })}>
                    <Paper
                        sx={{
                            display: 'flex',
                            justifyContent: 'left',
                            flexWrap: 'wrap',
                            listStyle: 'none',
                            boxShadow: "none",
                            background: "transparent",
                            p: 0.5,
                            m: 0,
                            width: "100%"
                        }}
                        component="div"
                    >
                            {this.state.usrs && this.state.usrs.length > 0 ?

                                    (this.state.usrs && this.state.usrs.length > 0) && this.state.usrs.map((item, index) => {
                                        return this.clientUser(item, index)
                                    })
                                :
                                <Typography sx={{ color: (theme) => this.props.dark ? theme.palette.common.dimwhite : theme.palette.common.dimblack, marginTop: "auto", marginBottom: "auto" }}>
                                    No client users have been added.  Click + Button to add users.
                                </Typography>
                            }
                        </Paper>
                 </Section>
                </ModalDialog>
                
            )
        }
        return null
    }
    invitedClientUser = (item, index) => {
        return (
            <SectionItem
                key={"inivted" + index}
                itemID={item.id}
                index={index}
                dark={this.props.dark}
                chipClickEdit={false}
                handleDelete={() => this.handleShowConfirmDeleteInvitedClientUser(item.id, index)}
            >
                <Box display="flex" sx={{ flexGrow: 1 }}>
                    <UserAvatar
                        id={item.user.userID}
                        user={item.user}
                        dark={this.props.dark}
                        loaded={true}
                        activeUser={this.props.user}
                        appIdentifier={this.props.appIdentifier}
                        hideName={false}
                        small
                    />
                    <Typography variant="body2" color="secondary" sx={{ ml: 5 }}>
                        {"Invited on " + new Date(item.dateSent).toLocaleDateString()}
                    </Typography>
                </Box>
            </SectionItem>
        )
    }
    clientUser = (item, index) => {
        return (
            <SectionItem
                key={"si" + index}
                itemID={item.id}
                index={index}
                dark={this.props.dark}
                chipClickEdit={false}
                handleDelete={() => this.deleteClientUser(item.id, index)}
                primaryContent={item.user.firstName + " " + item.user.lastName}
            >
                <Typography sx={{ width: "30%", color: (theme) => this.props.dark ? theme.palette.common.dimwhite : theme.palette.common.dimblack, marginTop: "auto", marginBottom: "auto" }}>
                    {item.user.email}
                </Typography>
                <Button

                    size="small"
                    color="secondary"
                    aria-label="emailinvite"
                    onClick={() => this.sendInvite(item.user)}

                >
                    Send Email Invitation
                </Button>
            </SectionItem>
        )
    }

    clientUserInvitation = () => {
        if (this.state.showClientUserInvitation) {
            return (
                <ModalDialog
                    {...this.props}
                    show={this.state.showClientUserInvitation}
                    title="Add new users"
                    subTitle="Find users to add by entering their name or email address."
                    fullWidth={true}
                    maxWidth="sm"
                    disableButtons={true}
                >
                    <Invitation
                        user={this.props.user}
                        dark={this.props.dark}
                        appIdentifier={this.props.appIdentifier}
                        updateInviteList={this.updateClientUserInviteList}
                        groupID={this.state.selectedClient}
                        businessID={this.props.businessID}
                        groupName={this.state.selectedClientName}
                        groupType="Client"
                        parentName={this.props.businessName}
                        handleCancel={() => this.setState({ showClientUserInvitation: false })}
                    />
                </ModalDialog>)
        }
        return null;
    } 

    handleNewClientUser = async (values) => {
        if (values && values.length > 0) {
            this.setState({ showNewClientUser: false });
            const user = await newClientUser(this.props.businessID, this.state.selectedClient, ...values);
            if (user) {
                const usrs = this.state.usrs;
                usrs.push(user);
                this.setState({ usrs });
            }

        }
    }
    clientUserCreator = () => {
        if (this.state.showNewClientUser) {
            return (
                <ItemCreator
                    dark={this.props.dark}
                    show={this.state.showNewClientUser}
                    width={this.props.width}
                    user={this.props.user}
                    item="Client User"
                    handleClose={() => this.setState({ showNewClientUser: false })}
                    handleSave={this.handleNewClientUser}
                    fields={this.state.newClientUserFields}
                />
            )
        }
        return null;
    }

    render() {
        return (
            <Box sx={{ pt: { xs: 7, sm: 8 } }} className={this.props.dark && "dark"} >
                {(this.state.clientData) &&
                    <Stack>
                        <Stack direction="row" spacing={2} sx={{ mx: 2, py:1}}>
                            <Typography  sx={{ color: (theme) => this.props.dark ? theme.palette.common.dimwhite : theme.palette.common.dimwhite, marginTop: "auto", marginBottom: "auto" }}>
                                {this.state.isAdmin ? "Select Client:" : "Select Account"}
                            </Typography>
                            {this.state.isAdmin ? this.adminTools()

                                :

                                <SelectListFilterable
                                    dark={this.props.dark}
                                    ckey="clientselect"

                                    value={this.state.selectedClient}
                                    onChange={this.handleClientChange}
                                    listItems={this.state.clientList}
                                    width="fit-content"
                                    minWidth="150px"
                                />
                            }

                        </Stack>
        {/*                {(this.state.documentFolders && this.state.documentFolders.length > 0) &&*/}
                            <ClientDocuments
                            dark={this.props.dark}
                            user={this.props.user}
                            clientID={this.state.selectedClient}
                            clientName={this.state.selectedClientName}
                            appIdentifier={"ls"}
                            profile={this.props.profile}
                            userList={this.props.userList}
                            folders={this.state.documentFolders}
                            updateFolders={this.updateFolders}
                            isAdmin={this.state.isAdmin }
                            />
                       {/* }*/}
                    </Stack>
                }
                {this.clientAdder()}
                {this.clientUsers()}
                {this.clientUserInvitation()}
                {this.clientUserCreator() }
            </Box>
        )
    }
}
